export const consentKey = "guitar-charts.analytics-consent.v1";
export const publicPages = {
  "/": "Create Scale Charts", "/library": "Library", "/blog": "Blog",
  "/training": "Ear Training", "/fretboard": "Fretboard Training",
  "/metronome": "Metronome", "/support": "Support",
  "/privacy": "Privacy", "/terms": "Terms of Use",
};

export function analyticsPage(pathname) {
  if (pathname === "/edit") return "/";
  if (/^\/library\/(saved|my-charts)(\/|$)/.test(pathname)) return null;
  if (pathname.startsWith("/library/")) return "/library";
  if (pathname.startsWith("/blog/")) return "/blog";
  return Object.hasOwn(publicPages, pathname) ? pathname : null;
}

export function readConsent() {
  try {
    const choice = localStorage.getItem(consentKey);
    return ["accepted", "declined"].includes(choice) ? choice : null;
  } catch { return null; }
}

export function forgetLegacyAnalyticsCookies() {
  // Never touch authentication storage or unrelated cookies.
  const domains = window.location.hostname.split(".");
  const suffixes = ["", window.location.hostname];
  for (let index = 0; index < domains.length - 1; index++) suffixes.push(`.${domains.slice(index).join(".")}`);
  try {
    for (const cookie of document.cookie.split(";")) {
      const name = cookie.trim().split("=")[0];
      if (!/^(_ga($|_)|_gid$|_gat($|_))/.test(name)) continue;
      for (const domain of suffixes) document.cookie = `${name}=;Max-Age=0;Path=/;SameSite=Lax${domain ? `;Domain=${domain}` : ""}`;
    }
  } catch { /* Cookie storage may be blocked by the browser. */ }
}
